import Api from '../../../commons/api';

export async function createUpdateVendorEvent(payload, type = 'create') {
  let method = 'post';
  let queryParams = '';
  let controller = 'vendor-events';
  if (type === 'update') {
    method = 'put';
    queryParams = `?vendorId=${payload.fk_vendor}&eventId=${payload.fk_event}`;
    controller = 'vendor-events/vendor-events/update/';
  }
  try {
    const { data } = await Api[method](`${controller}${queryParams}`, payload);
    return data;
  } catch (err) {
    console.error(err);
    throw new Error(err);
  }
}
